import React from 'react';
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {fixedPopper} from './tooltipConfig';

// Breite des ausgeklappten Labels in px (passt zu .hover-label-btn__label in app.scss);
// der Tooltip wird um diese Breite nach links geschoben, damit er das Label nicht verdeckt.
const LABEL_BREITE = 168;

/**
 * Knopf mit Hover-Beschriftung: Beim Überfahren (und bei Tastaturfokus) klappt
 * ein kurzes Label nach links aus, ohne das Layout zu verschieben. Der
 * ausführliche Tooltip folgt erst nach einer Verzögerung.
 */
export default function HoverLabelButton({label, tooltip, children, className, ...props}) {
    const knopf = (
        <Button {...props} className={`hover-label-btn${className ? ` ${className}` : ''}`}>
            <span className="hover-label-btn__label" aria-hidden="true">{label}</span>
            {children}
        </Button>
    );

    if (!tooltip) {
        return knopf;
    }

    return (
        <OverlayTrigger
            placement="left"
            delay={{show: 800, hide: 0}}
            popperConfig={fixedPopper([{name: 'offset', options: {offset: [0, LABEL_BREITE + 8]}}])}
            overlay={<Tooltip>{tooltip}</Tooltip>}
        >
            {knopf}
        </OverlayTrigger>
    );
}
